import { ReactElement, SVGProps } from 'react';

export default function LogoIcon(props: SVGProps<any>): ReactElement {
  return (
    <svg {...props} width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#a)">
        <mask id="b" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="2" y="2" width="13" height="13">
          <path d="M15 2H2v13h13z" fill="#fff" />
        </mask>
        <g mask="url(#b)">
          <path d="M14.148 5.84h-.01a.853.853 0 0 0-.852.854v7.453c0 .471.382.853.853.853h.009c.47 0 .852-.382.852-.853V6.694a.853.853 0 0 0-.852-.853" fill="#7A4CE1" />
          <path d="M11.311 8.086h-.008a.85.85 0 0 0-.853.85v5.215a.85.85 0 0 0 .853.849h.008a.85.85 0 0 0 .853-.85V8.936a.85.85 0 0 0-.853-.849" fill="#E27CA4" />
          <path d="M8.421 10.273h-.02a.85.85 0 0 0-.847.848v3.03c0 .47.38.849.847.849h.02c.468 0 .847-.38.847-.848v-3.03a.85.85 0 0 0-.847-.85" fill="url(#c)" />
          <path d="M4.36 14.956a2.36 2.36 0 1 0 0-4.72 2.36 2.36 0 0 0 0 4.72" fill="#F9E08F" />
          <path d="M4.369 14.662a2.047 2.047 0 1 0 0-4.094 2.047 2.047 0 0 0 0 4.094" fill="#F7CC46" />
          <path d="M5.521 12.717c-.64.191-.88.426-1.074 1.052-.034.11-.194.11-.228 0-.195-.626-.435-.86-1.074-1.052a.115.115 0 0 1 0-.222c.64-.191.879-.426 1.074-1.051.034-.11.194-.11.228 0 .195.625.435.86 1.074 1.05a.115.115 0 0 1 0 .223" fill="#fff" />
          <mask id="d" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="2" y="2" width="13" height="8">
            <path d="M15 2H2v7.86h13z" fill="#fff" />
          </mask>
          <g mask="url(#d)">
            <path d="m14.822 2.355-.013-.015a.845.845 0 0 0-1.186-.147L8.716 6.047a.485.485 0 0 1-.607-.006L3.396 2.19a.854.854 0 0 0-1.389.58A1 1 0 0 0 2 2.875v6.124c0 .473.384.86.855.86A.86.86 0 0 0 3.711 9V5.105c0-.177.203-.274.34-.163l3.793 3.097a.84.84 0 0 0 .43.184.84.84 0 0 0 .662-.167l5.74-4.508a.856.856 0 0 0 .146-1.193" fill="#7A4CE1" />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient id="c" x1="7.554" y1="12.636" x2="9.268" y2="12.636" gradientUnits="userSpaceOnUse">
          <stop stopColor="#59DEFF" />
        </linearGradient>
        <clipPath id="a">
          <path fill="#fff" d="M2 2h13v13H2z" />
        </clipPath>
      </defs>
    </svg>

  )
}
